import { Swiper, utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  constructor() {
    super()

    this.section = this.closest('.js-product-section')
    this.form = this.querySelector('form:not(.tvg-product-form)')
    this.quanityInput = this.querySelector('[name="quantity"]')

    /*
     * TG Custom START
     * Product: Gilded Nirvana: Mega Eye Shadow Palette
     *
     * Updated submit button selector so the TVG Add to Bag button
     * is also handled by this product form.
     *
     * Previously the selector excluded .tvg-product-form-button.
     */
    this.submitButton = this.querySelector('[type="submit"]')
    /*
     * TG Custom END
     * Product: Gilded Nirvana: Mega Eye Shadow Palette
     */

    console.log(this.submitButton)

    this.productSkin = this.querySelector('.js-product-skin')
    this.productData = JSON.parse(
      this.querySelector('.js-product-json').textContent
    )

    if (this.submitButton !== null) {
      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      )
    }

    this.querySelectorAll('.js-product-variants').forEach((select) => {
      select.addEventListener('change', (e) => {
        const triggerSwatch = !e.detail?.id
        this.onChangeVariant(e, triggerSwatch)
      })
    })

    this.productSkin?.addEventListener('click', (e) => {
      if (document.querySelector('.try-it-on') === null) return

      window.scroll({
        top:
          document.querySelector('.try-it-on').offsetTop -
          document.querySelector('.header-wrapper').clientHeight,
        behavior: 'smooth',
      })
    })

    this.dropdownProductFormSelector = this.querySelector(
      '.product-form__variant-item.product-form__variant-item--current'
    )

    this.dropdownProductFormSelectorMobile = this.querySelector(
      '.product-form__variant-item.product-form__variant-item--mobile-only'
    )

    this.dropdownProductFormCurrent = this.querySelectorAll(
      '.product-form__variant-item[data-current-variant-id]'
    )

    this.dropdownProductFormList = this.querySelector(
      '.product-form__variant-list'
    )

    this.dropdownProductFormListItems = this.querySelectorAll(
      '.js-product-form-item'
    )

    if (
      this.dropdownProductFormSelector &&
      this.dropdownProductFormList
    ) {
      this.dropdownProductFormSelector.addEventListener('click', () => {
        this.dropdownProductFormSelector.classList.toggle('expanded')
        this.dropdownProductFormList.classList.toggle('expanded')
      })
    }

    if (
      this.dropdownProductFormSelectorMobile &&
      this.dropdownProductFormList
    ) {
      this.dropdownProductFormSelectorMobile.addEventListener(
        'click',
        () => {
          this.dropdownProductFormSelector.classList.remove('expanded')
          this.dropdownProductFormList.classList.remove('expanded')
        }
      )
    }

    document.addEventListener('click', (event) => {
      const isInsideSelector =
        this.dropdownProductFormSelector?.contains(event.target)

      const isInsideList =
        this.dropdownProductFormList?.contains(event.target)

      if (!isInsideSelector && !isInsideList) {
        this.dropdownProductFormSelector?.classList?.remove('expanded')
        this.dropdownProductFormList?.classList?.remove('expanded')
      }
    })

    if (this.dropdownProductFormListItems.length > 0) {
      this.dropdownProductFormListItems.forEach((listItem) => {
        listItem.addEventListener('click', () => {
          const listItemVariantId = listItem.dataset.variantId

          const variantSwatches = document.querySelectorAll(
            'hh-variant-swatches .js-swatch-item'
          )

          if (variantSwatches.length > 0) {
            for (const swatch of variantSwatches) {
              const swatchId = swatch.dataset.id

              if (listItemVariantId === swatchId) {
                swatch.click()

                const swatchSwiper = swatch.closest(
                  '.js-slider.swiper-initialized'
                )

                if (!swatchSwiper) break

                const swiperInstance = swatchSwiper.swiper

                if (!swiperInstance) break

                let indexOfActiveElement = -1

                const swiperSwatches = swatchSwiper.querySelectorAll(
                  '.js-swatch-item:not(.hidden)'
                )

                for (let i = 0; i < swiperSwatches.length; i++) {
                  if (
                    swiperSwatches[i].classList.contains('active')
                  ) {
                    indexOfActiveElement = i
                    break
                  }
                }

                if (indexOfActiveElement !== -1) {
                  swiperInstance.slideTo(indexOfActiveElement)
                }

                break
              }
            }
          }
        })
      })
    }

    let ticking = false

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect()

          if (rect.top < 0) {
            const height = 152

            this.style.setProperty(
              '--form-float-height',
              `${height}px`
            )

            if (window.innerWidth < 750) {
              setTimeout(() => {
                this.classList.add('floating')
              }, 100)
            }
          } else {
            this.classList.remove('floating')
          }

          ticking = false
        })

        ticking = true
      }
    })

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750) {
        this.classList.remove('floating')
      }
    })
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  /*
   * TG Custom START
   * Product: Gilded Nirvana: Mega Eye Shadow Palette
   * Product ID: 7773029433413
   *
   * Helper method used to make sure the max quantity rule
   * applies only to this specific product.
   */
  isGildedNirvanaProduct() {
    return Number(this.productData?.id) === 7773029433413
  }

  /*
   * TG Custom
   * Product: Gilded Nirvana: Mega Eye Shadow Palette
   *
   * Show PDP error when customer attempts to exceed
   * the maximum allowed quantity of 4 per order.
   */
  showQuantityLimitError() {
    const message =
      'Maximum 4 Gilded Nirvana: Mega Eye Shadow Palettes are allowed per order.'

    let errorBox = this.querySelector('.js-product-form-error')

    if (!errorBox) {
      errorBox = document.createElement('div')
      errorBox.className = 'js-product-form-error'

      if (this.submitButton?.parentElement) {
        this.submitButton.parentElement.before(errorBox)
      }
    }

    if (errorBox) {
      errorBox.textContent = message
      errorBox.style.display = 'block'
      errorBox.style.marginBottom = '12px'
      errorBox.style.marginTop = '12px'
      errorBox.style.color = '#d70000'
      errorBox.style.fontSize = '14px'
    }
  }

  /*
   * TG Custom
   * Product: Gilded Nirvana: Mega Eye Shadow Palette
   *
   * Clear the PDP quantity limit message before
   * processing another Add to Bag attempt.
   */
  clearQuantityLimitError() {
    const errorBox = this.querySelector('.js-product-form-error')

    if (errorBox) {
      errorBox.textContent = ''
      errorBox.style.display = 'none'
    }
  }

  /*
   * TG Custom
   * Product: Gilded Nirvana: Mega Eye Shadow Palette
   *
   * Read the current Shopify cart and calculate how many
   * units of this product are already in the cart.
   *
   * This allows the PDP to block an Add to Bag action
   * that would take the total quantity above 4.
   */
  async getGildedNirvanaCartQuantity() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(
          `Unable to load cart. Status: ${response.status}`
        )
      }

      const cart = await response.json()

      return cart.items
        .filter(
          (item) =>
            Number(item.product_id) === 7773029433413
        )
        .reduce(
          (total, item) =>
            total + Number(item.quantity || 0),
          0
        )
    } catch (error) {
      console.error(
        'Unable to check Gilded Nirvana cart quantity:',
        error
      )

      return 0
    }
  }
  /*
   * TG Custom END
   * Product: Gilded Nirvana: Mega Eye Shadow Palette
   * Helper methods for PDP max quantity validation.
   */

  async onSubmitHandler(event) {
    event.preventDefault()

    /*
     * TG Custom
     * Product: Gilded Nirvana: Mega Eye Shadow Palette
     *
     * Clear any previous quantity-limit message before
     * checking the next Add to Bag request.
     */
    this.clearQuantityLimitError()

    const product = JSON.parse(
      serializeForm(this.form)
    )

    /*
     * TG Custom START
     * Product: Gilded Nirvana: Mega Eye Shadow Palette
     *
     * Maximum quantity: 4 per order.
     *
     * Examples:
     * Cart qty 0 + Add 1 = allowed
     * Cart qty 1 + Add 1 = allowed
     * Cart qty 2 + Add 1 = blocked
     */
    if (this.isGildedNirvanaProduct()) {
      const requestedQuantity =
        Number(product.quantity || 1)

      const currentCartQuantity =
        await this.getGildedNirvanaCartQuantity()

      if (
        currentCartQuantity + requestedQuantity > 4
      ) {
        this.showQuantityLimitError()
        return
      }
    }
    /*
     * TG Custom END
     * Product: Gilded Nirvana: Mega Eye Shadow Palette
     * PDP max quantity validation.
     */

    this.submitButton.setAttribute(
      'disabled',
      true
    )

    this.submitButton.classList.add(
      'loading'
    )

    const productData = product

    window.dispatchEvent(
      new CustomEvent('tvg-cart-add', {
        detail: {
          product: productData,
        },
        bubbles: true,
        composed: true,
      })
    )

    this.submitButton.removeAttribute(
      'disabled'
    )

    this.submitButton.classList.remove(
      'loading'
    )
  }

  onChangeVariant(e, triggerSwatch = true) {
    const value = e.detail?.id || e.target.value

    if (!value) return

    const input = this.querySelector(
      'input[name="id"]'
    )

    input.value = value

    input.dispatchEvent(
      new Event('change', {
        bubbles: true,
      })
    )

    const activeVariant =
      this.productData.variants.find(
        (variant) => +variant.id === +value
      )

    if (activeVariant.available) {
      this.querySelector(
        '[type="submit"]'
      )?.removeAttribute('disabled')
    } else {
      this.querySelector(
        '[type="submit"]'
      )?.setAttribute(
        'disabled',
        true
      )
    }

    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${value}`
    )

    if (!triggerSwatch) return

    this.section
      ?.querySelectorAll(
        '.js-variant-swatches'
      )
      .forEach((swatches) => {
        swatches.dispatchEvent(
          new CustomEvent(
            'SWATCH_CHANGE',
            {
              bubbles: true,
              detail: {
                id: value,
              },
            }
          )
        )
      })

    const productFormItems =
      this.section?.querySelectorAll(
        '.js-product-form-item'
      )

    if (productFormItems.length > 0) {
      productFormItems.forEach(
        (formItem) => {
          const formItemId =
            formItem.dataset.variantId

          if (formItemId === value) {
            formItem.classList.add(
              'product-form__variant-item--list-item-selected'
            )

            const currentProductFormItems =
              this.section?.querySelectorAll(
                '[data-current-variant-id]'
              )

            if (
              currentProductFormItems.length >
              0
            ) {
              currentProductFormItems.forEach(
                (currentFormItem) => {
                  currentFormItem.dataset.currentVariant =
                    value

                  const currentProductFormItemTitle =
                    currentFormItem.querySelector(
                      '[data-current-title]'
                    )

                  if (
                    currentProductFormItemTitle
                  ) {
                    currentProductFormItemTitle.innerHTML =
                      formItem.dataset.variantTitle
                  }
                }
              )
            }
          } else {
            formItem.classList.remove(
              'product-form__variant-item--list-item-selected'
            )
          }
        }
      )
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define(
  'hh-product-form',
  HHProductForm
)